import { Autocomplete, TextField } from "@mui/material";
import { useResourcesContext } from "app/contexts/resources";
import { useEffect, useState } from "react";

export function MunicipioAutocomplete({
  label = "Municipio",
  value = 0,
  onChange = () => {},
  required = true,
  disabled = false,
}) {
  const { ciudades } = useResourcesContext();

  const [options] = useState(() =>
    ciudades.map((ciudad) => ({
      label: `${ciudad.ciudad_nombre}`,
      ...ciudad,
    }))
  );

  const [currentValue, setCurrentValue] = useState(null);

  useEffect(() => {
    const option = options.find((option) => option.ciudad_id === value);

    setCurrentValue(option || null);
  }, [options, value]);

  return (
    <Autocomplete
      value={currentValue}
      options={options}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} size="small" />
      )}
      onChange={(e, value) => {
        setCurrentValue(value);

        return onChange(value?.ciudad_id || 0);
      }}
      disabled={disabled}
    />
  );
}
